import classNames from 'classnames'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles, Testable, WithOptionalChildren } from 'utils-next/types'

import { Button, Paper, Theme, Toolbar } from '@mui/material'

export type FormActionBarProps = ExtendableStyles &
  Testable &
  WithOptionalChildren & {
    onSubmit: () => void
  }

export function FormActionBar({ children, className, onSubmit, ...otherProps }: FormActionBarProps) {
  const { classes } = useStyles()
  return (
    <Toolbar component={Paper} className={classNames(className, classes.content)} {...otherProps}>
      <div className={classes.additionalButtons}>{children}</div>
      <Button color="secondary" variant="contained" onClick={onSubmit}>
        Submit
      </Button>
    </Toolbar>
  )
}

export const useStyles = makeStyles()(({ spacing }: Theme) => ({
  content: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: spacing(5),
  },
  additionalButtons: {
    width: '100%',
    position: 'relative',
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    gap: spacing(2),
  },
}))
